var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrintIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#C1C9D1",
  rx: 5.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#53595E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 13.5V9.75h12v3.75m-12 9H8.25V15c0-.829.727-1.5 1.625-1.5h16.25c.898 0 1.625.671 1.625 1.5v7.5H24m-12-2.25h12v6H12z"
})));
export { SvgPrintIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/print-icon.481eac4c.svg";